<template>
  <div class="widget">
    <h3>二手交易
      <router-link to="/oldstuff" class="more">更多&gt;</router-link>
    </h3>
    <div class="stuff-grid">
      <div class="stuff-card" v-for="item in tableData" :key="item.oldstuff_id">
        <router-link class="thumbnail" :to="`/oldstuffcontent/${item.oldstuff_id}`">
          <img :src="item.oldstuff_img" :alt="item.oldstuff_name" />
          <div class="caption">
            <div class="price">￥{{ item.oldstuff_price }}</div>
            <div class="name">{{ item.oldstuff_name }}</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getOldstuffList } from '@/api'

export default {
  name: 'OldstuffWidget',
  data() {
    return { tableData: [] }
  },
  created() {
    getOldstuffList({ page: 1, pagesize: 6 }).then((res) => {
      this.tableData = res.data || []
    })
  }
}
</script>
